import React from 'react';

import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { publisherRulesAutoCompleteInput$, publisherRulesAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const renderSuggestion = (suggestion) => (
   <div>
      {' '}
      {suggestion.name}
      {' '}
   </div>
);

const PublishersRulesAutoSuggest = renderAutoSuggestWithOptions(
   publisherRulesAutoCompleteObservable$,
   publisherRulesAutoCompleteInput$,
   renderSuggestion,
);

PublishersRulesAutoSuggest.defaultProps = {
   // selected: {
   //    id: null,
   //    name: ''
   // },
   // filterOrganization: {
   //    id: null,
   //    name: ''
   // },
   forceSelection: false,
   placeholder: 'Search Rules...',
};

export default PublishersRulesAutoSuggest;
